import React, { useState } from "react";
import { Modal, Form, Input, message, Progress, Alert } from "antd";
import { adminSetUserPassword } from "../../api/Usuarios";

const calcularFuerza = (password) => {
  let fuerza = 0;
  if (!password) return 0;
  if (password.length >= 8) fuerza += 1;
  if (/[A-Z]/.test(password)) fuerza += 1;
  if (/[a-z]/.test(password)) fuerza += 1;
  if (/\d/.test(password)) fuerza += 1;
  if (/[\W_]/.test(password)) fuerza += 1;
  return fuerza;
};

const fuerzaToStatus = (fuerza) => {
  if (fuerza <= 1) return "exception";
  if (fuerza <= 3) return "normal";
  return "success";
};

const extraerError = (error) => {
  const data = error?.response?.data;
  if (data) {
    const pick = (v) => (Array.isArray(v) ? v[0] : v);
    if (data.new_password) return pick(data.new_password);
    if (data.detail) return data.detail;
  }
  return "No se pudo cambiar la contraseña.";
};

const AdminSetPasswordModal = ({ open, onClose, user }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const cerrar = () => {
    form.resetFields();
    setNewPassword("");
    onClose();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await adminSetUserPassword(user.id, values.new_password);
      message.success(`Contraseña de "${user.username}" actualizada con éxito.`);
      cerrar();
    } catch (error) {
      if (error?.response) {
        message.error(extraerError(error));
      }
      // errores de validación del formulario: AntD los muestra en los campos
    } finally {
      setLoading(false);
    }
  };

  const fuerza = calcularFuerza(newPassword);

  return (
    <Modal
      open={open}
      title="Cambiar contraseña de usuario"
      onCancel={cerrar}
      onOk={handleOk}
      okText="Guardar contraseña"
      cancelText="Cancelar"
      confirmLoading={loading}
      destroyOnClose
      centered
      width={420}
    >
      {user && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message={
            <span>
              Estableciendo una nueva contraseña para <b>{user.username}</b>. No se
              requiere la contraseña anterior.
            </span>
          }
        />
      )}
      <Form form={form} layout="vertical">
        <Form.Item
          name="new_password"
          label="Nueva contraseña"
          rules={[
            { required: true, message: "Ingresa la nueva contraseña" },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
              message:
                "Debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un símbolo",
            },
          ]}
        >
          <Input.Password
            autoComplete="new-password"
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </Form.Item>

        {newPassword && (
          <div style={{ marginTop: -12, marginBottom: 12 }}>
            <Progress
              percent={(fuerza / 5) * 100}
              status={fuerzaToStatus(fuerza)}
              showInfo={false}
            />
            <div style={{ textAlign: "right", fontSize: 12 }}>
              {["Muy débil", "Débil", "Aceptable", "Buena", "Fuerte"][fuerza - 1] ||
                "Muy débil"}
            </div>
          </div>
        )}

        <Form.Item
          name="confirm_password"
          label="Confirmar nueva contraseña"
          dependencies={["new_password"]}
          rules={[
            { required: true, message: "Confirma la nueva contraseña" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Las contraseñas no coinciden"));
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AdminSetPasswordModal;
